module.exports = __webpack_public_path__ + "5d06ff26ca295e1902ab7d919e7f9818.svg";